const values = Object.freeze({
  MetodosEvaluacionUtilizados: 1,
  VocationalInterestsOccupationalPreferences: 2,
  BasicAcademicSkillsAcademicAchievement: 3,
  PerformanceBasedWorkSampleBasedEvaluation: 4,
  LearningStylesProcesses: 5,
  ComplementaryMethodsEvaluationObservation: 6,
  PropositoEvaluacionVocacional: 7,
  LenguajePrincipal: 8,
  ModosComunicacionExpresionOral: 9,
  AparienciaGeneral: 10,
  RelacionExaminadora: 11,
  Disposicion: 12,
  NivelAtencion: 13,
  NivelActividad: 14,
  NivelEjecucion: 15,
  ConductaObservada: 16,
  ToleranciaALasFallas: 17,
  Lateralidad: 18,
  CapacidadParaSeguirInstrucciones: 20,
  OrigenHistorialPsicosocial: 21,
  ComunicacionObservada: 54,
});
export default values;
